import React from "react";
import PageHeader from "../components/PageHeader";
import { FileCheck, Hand , Shield, AlertTriangle, ExternalLink } from "lucide-react";

export default function Terms() {
  return (
    <>
      <PageHeader
        title="Terms & Conditions"
        subtitle="Please review the following terms before using AQUIRAA's website and services."
      />

      <div className="w-full h-[3px] bg-gradient-to-r from-transparent via-[#00C4CC] to-transparent animate-pulseGlow mb-10"></div>

      <div className="max-w-6xl mx-auto px-6 py-12 space-y-14">

        {/* Intro */}
        <div className="bg-white shadow rounded-2xl p-8 border">
          <p className="text-gray-700 leading-7">
            These Terms & Conditions apply to all users of AQUIRAA’s services. By accessing 
            our website or related services, you agree to comply with these terms.
          </p>
        </div>

        {/* Section 1 */}
        <div>
          <div className="flex items-center gap-3 mb-3">
            <FileCheck size={26} className="text-aquiraaBlue" />
            <h2 className="text-2xl font-semibold text-[#0A1E3F]">1. Acceptance of Terms</h2>
          </div>

          <p className="text-gray-700 bg-gray-50 p-6 rounded-xl border leading-7">
            By using our website, you acknowledge that you have read and agree to these Terms 
            & Conditions, as well as any additional policies posted.
          </p>
        </div>

        {/* Section 2 */}
        <div>
          <div className="flex items-center gap-3 mb-3">
            <Hand  size={26} className="text-aquiraaBlue" />
            <h2 className="text-2xl font-semibold text-[#0A1E3F]">2. Service Usage</h2>
          </div>

          <div className="bg-white shadow p-6 rounded-xl border">
            <p className="text-gray-700 leading-7">
              You agree to use AQUIRAA services for lawful business purposes only. Any misuse,
              data scraping, or unauthorized copying is strictly prohibited.
            </p>
          </div>
        </div>

        {/* Section 3 */}
        <div>
          <div className="flex items-center gap-3 mb-3">
            <Shield size={26} className="text-aquiraaBlue" />
            <h2 className="text-2xl font-semibold text-[#0A1E3F]">
              3. Liability & Limitations
            </h2>
          </div>

          <p className="text-gray-700 leading-7 bg-gray-50 p-6 rounded-xl border">
            AQUIRAA is not liable for indirect or incidental damages.  
            Data accuracy depends on source availability and client usage.
          </p>
        </div>

        {/* Section 4 */}
        <div>
          <div className="flex items-center gap-3 mb-3">
            <ExternalLink size={26} className="text-aquiraaBlue" />
            <h2 className="text-2xl font-semibold text-[#0A1E3F]">
              4. Third-Party Links
            </h2>
          </div>

          <p className="text-gray-700 leading-7 bg-white shadow p-6 rounded-xl border">
            Our website may link to external third-party sites.  
            We do not control, endorse, or take responsibility for external content.
          </p>
        </div>

        {/* Section 5 */}
        <div>
          <div className="flex items-center gap-3 mb-3">
            <AlertTriangle size={26} className="text-aquiraaBlue" />
            <h2 className="text-2xl font-semibold text-[#0A1E3F]">5. Termination Rights</h2>
          </div>

          <p className="text-gray-700 leading-7 bg-gray-50 p-6 rounded-xl border">
            We reserve the right to suspend or remove access if misuse or violations are detected.
          </p>
        </div>

      </div>

      <style>
        {`
          @keyframes pulseGlow {
            0% { opacity: 0.3; }
            50% { opacity: 1; }
            100% { opacity: 0.3; }
          }
          .animate-pulseGlow {
            animation: pulseGlow 2.2s infinite ease-in-out;
          }
        `}
      </style>
    </>
  );
}
